import tokens from '../tokens/js/tokens';
// Definition of the "negative" color schema
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Hard
export const NEGATIVE_LIGHT_HARD_DEFAULT = {
    background: tokens.colors.red[600].value,
    border: tokens.colors.red[600].value,
    foregroundAlt: tokens.colors.red[200].value,
    foreground: tokens.colors.white[100].value
};
// Light + Hard + Hover
export const NEGATIVE_LIGHT_HARD_HOVER = {
    background: tokens.colors.red[700].value,
    border: tokens.colors.red[700].value,
    foregroundAlt: tokens.colors.red[300].value,
    foreground: tokens.colors.white[100].value
};
// Light + Hard + Pressed
export const NEGATIVE_LIGHT_HARD_PRESSED = {
    background: tokens.colors.red[800].value,
    border: tokens.colors.red[800].value,
    foregroundAlt: tokens.colors.red[400].value,
    foreground: tokens.colors.white[100].value
};
// Light + Hard + Focus
export const NEGATIVE_LIGHT_HARD_FOCUS = {
    background: tokens.colors.red[600].value,
    border: tokens.colors.red[600].value,
    foregroundAlt: tokens.colors.red[200].value,
    foreground: tokens.colors.white[100].value
};
// Light + Hard + Disabled
export const NEGATIVE_LIGHT_HARD_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[150].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Soft + Default
export const NEGATIVE_LIGHT_SOFT_DEFAULT = {
    background: tokens.colors.red[100].value,
    border: tokens.colors.red[300].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[900].value
};
// Light + Soft + Hover
export const NEGATIVE_LIGHT_SOFT_HOVER = {
    background: tokens.colors.red[200].value,
    border: tokens.colors.red[400].value,
    foregroundAlt: tokens.colors.red[600].value,
    foreground: tokens.colors.red[900].value
};
// Light + Soft + Pressed
export const NEGATIVE_LIGHT_SOFT_PRESSED = {
    background: tokens.colors.red[300].value,
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[700].value,
    foreground: tokens.colors.red[900].value
};
// Light + Soft + Focus
export const NEGATIVE_LIGHT_SOFT_FOCUS = {
    background: tokens.colors.red[100].value,
    border: tokens.colors.red[300].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[900].value
};
// Light + Soft + Disabled
export const NEGATIVE_LIGHT_SOFT_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + White + Default
export const NEGATIVE_LIGHT_WHITE_DEFAULT = {
    background: tokens.colors.red[100].value,
    border: tokens.colors.red[300].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[900].value
};
// Light + White + Hover
export const NEGATIVE_LIGHT_WHITE_HOVER = {
    background: tokens.colors.red[200].value,
    border: tokens.colors.red[400].value,
    foregroundAlt: tokens.colors.red[600].value,
    foreground: tokens.colors.red[900].value
};
// Light + White + Pressed
export const NEGATIVE_LIGHT_WHITE_PRESSED = {
    background: tokens.colors.red[300].value,
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[700].value,
    foreground: tokens.colors.red[900].value
};
// Light + White + Focus
export const NEGATIVE_LIGHT_WHITE_FOCUS = {
    background: tokens.colors.red[100].value,
    border: tokens.colors.red[300].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[900].value
};
// Light + White + Dissabled
export const NEGATIVE_LIGHT_WHITE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Ghost + Hard
export const NEGATIVE_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[700].value
};
// Light + Ghost + Hover
export const NEGATIVE_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: tokens.colors.red[700].value,
    foregroundAlt: tokens.colors.red[700].value,
    foreground: tokens.colors.red[700].value
};
// Light + Ghost + Pressed
export const NEGATIVE_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[500].value
};
// Light + Ghost + Focus
export const NEGATIVE_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[700].value
};
// Light + Ghost + Disabled
export const NEGATIVE_LIGHT_GHOST_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Bare + Hard
export const NEGATIVE_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[700].value
};
// Light + Bare + Hover
export const NEGATIVE_LIGHT_BARE_HOVER = {
    background: tokens.colors.red[150].value,
    border: tokens.colors.red[150].value,
    foregroundAlt: tokens.colors.red[600].value,
    foreground: tokens.colors.red[900].value
};
// Light + Bare + Pressed
export const NEGATIVE_LIGHT_BARE_PRESSED = {
    background: tokens.colors.red[200].value,
    border: tokens.colors.red[200].value,
    foregroundAlt: tokens.colors.red[600].value,
    foreground: tokens.colors.red[900].value
};
// Light + Bare + Focus
export const NEGATIVE_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Bare + Disabled
export const NEGATIVE_LIGHT_BARE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Hard
export const NEGATIVE_DARK_HARD_DEFAULT = {
    background: tokens.colors.red[600].value,
    border: tokens.colors.red[600].value,
    foregroundAlt: tokens.colors.red[200].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Hard + Hover
export const NEGATIVE_DARK_HARD_HOVER = {
    background: tokens.colors.red[700].value,
    border: tokens.colors.red[700].value,
    foregroundAlt: tokens.colors.red[300].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Hard + Pressed
export const NEGATIVE_DARK_HARD_PRESSED = {
    background: tokens.colors.red[800].value,
    border: tokens.colors.red[800].value,
    foregroundAlt: tokens.colors.red[400].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Hard + Focus
export const NEGATIVE_DARK_HARD_FOCUS = {
    background: tokens.colors.red[600].value,
    border: tokens.colors.red[600].value,
    foregroundAlt: tokens.colors.red[200].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Hard + Disabled
export const NEGATIVE_DARK_HARD_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Soft + Default
export const NEGATIVE_DARK_SOFT_DEFAULT = {
    background: tokens.colors.red[600].value,
    border: tokens.colors.red[600].value,
    foregroundAlt: tokens.colors.red[200].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Soft + Hover
export const NEGATIVE_DARK_SOFT_HOVER = {
    background: tokens.colors.red[700].value,
    border: tokens.colors.red[700].value,
    foregroundAlt: tokens.colors.red[300].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Soft + Pressed
export const NEGATIVE_DARK_SOFT_PRESSED = {
    background: tokens.colors.red[800].value,
    border: tokens.colors.red[800].value,
    foregroundAlt: tokens.colors.red[400].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Soft + Focus
export const NEGATIVE_DARK_SOFT_FOCUS = {
    background: tokens.colors.red[600].value,
    border: tokens.colors.red[600].value,
    foregroundAlt: tokens.colors.red[200].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Soft + Disabled
export const NEGATIVE_DARK_SOFT_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + White + Default
export const NEGATIVE_DARK_WHITE_DEFAULT = {
    background: tokens.colors.red[100].value,
    border: tokens.colors.red[300].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[900].value
};
// Dark + White + Hover
export const NEGATIVE_DARK_WHITE_HOVER = {
    background: tokens.colors.red[200].value,
    border: tokens.colors.red[400].value,
    foregroundAlt: tokens.colors.red[600].value,
    foreground: tokens.colors.red[900].value
};
// Dark + White + Pressed
export const NEGATIVE_DARK_WHITE_PRESSED = {
    background: tokens.colors.red[300].value,
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[700].value,
    foreground: tokens.colors.red[900].value
};
// Dark + White + Focus
export const NEGATIVE_DARK_WHITE_FOCUS = {
    background: tokens.colors.red[100].value,
    border: tokens.colors.red[300].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[900].value
};
// Dark + White + Dissabled
export const NEGATIVE_DARK_WHITE_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Ghost + Hard
export const NEGATIVE_DARK_GHOST_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[500].value
};
// Dark + Ghost + Hover
export const NEGATIVE_DARK_GHOST_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.red[300].value,
    foregroundAlt: tokens.colors.red[300].value,
    foreground: tokens.colors.red[300].value
};
// Dark + Ghost + Pressed
export const NEGATIVE_DARK_GHOST_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.red[700].value,
    foregroundAlt: tokens.colors.red[700].value,
    foreground: tokens.colors.red[700].value
};
// Dark + Ghost + Focus
export const NEGATIVE_DARK_GHOST_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[500].value
};
// Dark + Ghost + Disabled
export const NEGATIVE_DARK_GHOST_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Bare + Hard
export const NEGATIVE_DARK_BARE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[500].value
};
// Dark + Bare + Hover
export const NEGATIVE_DARK_BARE_HOVER = {
    background: tokens.colors.red[850].value,
    border: tokens.colors.red[850].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Bare + Pressed
export const NEGATIVE_DARK_BARE_PRESSED = {
    background: tokens.colors.red[900].value,
    border: tokens.colors.red[900].value,
    foregroundAlt: tokens.colors.red[300].value,
    foreground: tokens.colors.white[100].value
};
// Dark + Bare + Focus
export const NEGATIVE_DARK_BARE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.red[500].value,
    foregroundAlt: tokens.colors.red[500].value,
    foreground: tokens.colors.red[500].value
};
// Dark + Bare + Disabled
export const NEGATIVE_DARK_BARE_DISABLED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
export const NEGATIVE_LIGHT_HARD = {
    default: NEGATIVE_LIGHT_HARD_DEFAULT,
    disabled: NEGATIVE_LIGHT_HARD_DISABLED,
    focus: NEGATIVE_LIGHT_HARD_FOCUS,
    hover: NEGATIVE_LIGHT_HARD_HOVER,
    pressed: NEGATIVE_LIGHT_HARD_PRESSED
};
// Light + Soft
export const NEGATIVE_LIGHT_SOFT = {
    default: NEGATIVE_LIGHT_SOFT_DEFAULT,
    disabled: NEGATIVE_LIGHT_SOFT_DISABLED,
    focus: NEGATIVE_LIGHT_SOFT_FOCUS,
    hover: NEGATIVE_LIGHT_SOFT_HOVER,
    pressed: NEGATIVE_LIGHT_SOFT_PRESSED
};
// Light + White
export const NEGATIVE_LIGHT_WHITE = {
    default: NEGATIVE_LIGHT_WHITE_DEFAULT,
    disabled: NEGATIVE_LIGHT_WHITE_DISABLED,
    focus: NEGATIVE_LIGHT_WHITE_FOCUS,
    hover: NEGATIVE_LIGHT_WHITE_HOVER,
    pressed: NEGATIVE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
export const NEGATIVE_LIGHT_GHOST = {
    default: NEGATIVE_LIGHT_GHOST_DEFAULT,
    disabled: NEGATIVE_LIGHT_GHOST_DISABLED,
    focus: NEGATIVE_LIGHT_GHOST_FOCUS,
    hover: NEGATIVE_LIGHT_GHOST_HOVER,
    pressed: NEGATIVE_LIGHT_GHOST_PRESSED
};
// Light + Bare
export const NEGATIVE_LIGHT_BARE = {
    default: NEGATIVE_LIGHT_BARE_DEFAULT,
    disabled: NEGATIVE_LIGHT_BARE_DISABLED,
    focus: NEGATIVE_LIGHT_BARE_FOCUS,
    hover: NEGATIVE_LIGHT_BARE_HOVER,
    pressed: NEGATIVE_LIGHT_BARE_PRESSED
};
// Dark + Hard
export const NEGATIVE_DARK_HARD = {
    default: NEGATIVE_DARK_HARD_DEFAULT,
    disabled: NEGATIVE_DARK_HARD_DISABLED,
    focus: NEGATIVE_DARK_HARD_FOCUS,
    hover: NEGATIVE_DARK_HARD_HOVER,
    pressed: NEGATIVE_DARK_HARD_PRESSED
};
// Dark + Soft
export const NEGATIVE_DARK_SOFT = {
    default: NEGATIVE_DARK_SOFT_DEFAULT,
    disabled: NEGATIVE_DARK_SOFT_DISABLED,
    focus: NEGATIVE_DARK_SOFT_FOCUS,
    hover: NEGATIVE_DARK_SOFT_HOVER,
    pressed: NEGATIVE_DARK_SOFT_PRESSED
};
// Dark + White
export const NEGATIVE_DARK_WHITE = {
    default: NEGATIVE_DARK_WHITE_DEFAULT,
    disabled: NEGATIVE_DARK_WHITE_DISABLED,
    focus: NEGATIVE_DARK_WHITE_FOCUS,
    hover: NEGATIVE_DARK_WHITE_HOVER,
    pressed: NEGATIVE_DARK_WHITE_PRESSED
};
// Dark + Ghost
export const NEGATIVE_DARK_GHOST = {
    default: NEGATIVE_DARK_GHOST_DEFAULT,
    disabled: NEGATIVE_DARK_GHOST_DISABLED,
    focus: NEGATIVE_DARK_GHOST_FOCUS,
    hover: NEGATIVE_DARK_GHOST_HOVER,
    pressed: NEGATIVE_DARK_GHOST_PRESSED
};
// Dark + Bare
export const NEGATIVE_DARK_BARE = {
    default: NEGATIVE_DARK_BARE_DEFAULT,
    disabled: NEGATIVE_DARK_BARE_DISABLED,
    focus: NEGATIVE_DARK_BARE_FOCUS,
    hover: NEGATIVE_DARK_BARE_HOVER,
    pressed: NEGATIVE_DARK_BARE_PRESSED
};
// Light
export const NEGATIVE_LIGHT = {
    bare: NEGATIVE_LIGHT_BARE,
    ghost: NEGATIVE_LIGHT_GHOST,
    hard: NEGATIVE_LIGHT_HARD,
    soft: NEGATIVE_LIGHT_SOFT,
    white: NEGATIVE_LIGHT_WHITE
};
// Dark
export const NEGATIVE_DARK = {
    bare: NEGATIVE_DARK_BARE,
    ghost: NEGATIVE_DARK_GHOST,
    hard: NEGATIVE_DARK_HARD,
    soft: NEGATIVE_DARK_SOFT,
    white: NEGATIVE_DARK_WHITE
};
// Color schema
const NEGATIVE = {
    dark: NEGATIVE_DARK,
    light: NEGATIVE_LIGHT
};
export default NEGATIVE;
//# sourceMappingURL=palette.schema.negative.js.map